import './index.css'
import * as React from 'react'
import enhanceWithClickOutside from 'react-click-outside'
import { useNavigate } from 'react-router-dom'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { useDispatch } from 'hooks/use-redux'
import ContactUsLink from 'components/ui/contact-us-link'
import Heading from 'components/ui/heading'
import Icon from 'components/ui/icon'
import ModalWindow from 'components/ui/modal-window'
import Popover from 'components/ui/popover'

const isMac = navigator.platform.includes('Mac')

const HeaderHelpMenu = (): React.ReactNode => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [menuOpen, setMenuOpen] = React.useState(false)
  const [shortcutsModalOpen, setShortcutsModalOpen] = React.useState(false)

  const _onContactClick = () =>
    dispatch(sendMixpanelEvent('Open contact support'))
  const _onDemoClick = () => dispatch(sendMixpanelEvent('Open book a demo'))
  const _toggleShortcutsOpen = () => setShortcutsModalOpen(!shortcutsModalOpen)
  const _toggleMenuOpen = () => setMenuOpen(!menuOpen)
  const handleClickOutside = () => setMenuOpen(false)
  const _handleOptionClick = option => {
    switch (option.label) {
      case 'School of DISCO':
        dispatch(sendMixpanelEvent('Open school of DISCO'))
        break

      case 'Getting started guide':
        dispatch(sendMixpanelEvent('Open getting started guide'))
        break

      case 'Support Center':
        dispatch(sendMixpanelEvent('Open support center'))
        break

      case 'Watch a demo':
        dispatch(sendMixpanelEvent('Open demo video'))
        break

      case 'Book a demo':
        dispatch(sendMixpanelEvent('Open book a demo'))
        break
    }
  }

  const _renderMenu = () => {
    if (!menuOpen) return null
    return (
      <div className={`HeaderHelpMenu_Dropdown is-open`}>
        <Popover
          compact
          items={[
            {
              type: 'router-link',
              link: {
                url: 'https://school.disco.ac',
                target: '_blank',
              },
              label: 'School of DISCO',
            },
            {
              type: 'router-link',
              link: {
                url: 'https://school.disco.ac/handbook/new-to-disco',
                target: '_blank',
              },
              label: 'Getting started guide',
            },
            {
              type: 'router-link',
              link: {
                url: 'https://support.disco.ac/home',
                target: '_blank',
              },
              label: 'Support Center',
            },
            {
              type: 'router-link',
              link: {
                url: '/demo',
              },
              label: 'Watch a demo',
            },
            {
              label: (
                <ContactUsLink
                  className="HeaderHelpMenu_Link hidden-mobile"
                  intercomMsg="I'd like to book a demo"
                  onClick={_onDemoClick}
                >
                  Book a demo
                </ContactUsLink>
              ),
            },
            {
              label: 'Keyboard shortcuts',
              onClick: _toggleShortcutsOpen,
            },
            {
              label: (
                <ContactUsLink
                  className="HeaderHelpMenu_Link hidden-mobile"
                  onClick={_onContactClick}
                >
                  Contact support
                </ContactUsLink>
              ),
            },
          ]}
          onClick={_handleOptionClick}
        />
      </div>
    )
  }

  return (
    <>
      <button
        className="HeaderHelpMenu_Button"
        type="button"
        onClick={_toggleMenuOpen}
      >
        <Icon type="help" width="24" height="24" />
        {_renderMenu()}
      </button>
      <ModalWindow
        header={<Heading>Keyboard shortcuts</Heading>}
        isOpen={shortcutsModalOpen}
        width="small"
        onClose={_toggleShortcutsOpen}
      >
        <div className="HeaderHelpMenu_Row">
          <span>Move back/forward through playlists </span>

          <span className="HeaderHelpMenu_TagWrapper">
            <div className="HeaderHelpMenu_Tag">←</div>
            <div className="HeaderHelpMenu_Plus" />
            <div className="HeaderHelpMenu_Tag">→</div>
          </span>
        </div>
        <div className="HeaderHelpMenu_Row">
          <span>Pause/Playback</span>
          <span className="HeaderHelpMenu_TagWrapper">
            <div className="HeaderHelpMenu_Tag">Space</div>
          </span>
        </div>
        <div className="HeaderHelpMenu_Row">
          <span>Individual items select</span>

          <span className="HeaderHelpMenu_TagWrapper">
            <div className="HeaderHelpMenu_Tag">
              <span>{isMac ? '⌘' : 'ctrl'}</span>
            </div>
            <div className="HeaderHelpMenu_Plus">+</div>
            <div className="HeaderHelpMenu_Tag">Click</div>
          </span>
        </div>
        <div className="HeaderHelpMenu_Row">
          <span>Range select</span>

          <span className="HeaderHelpMenu_TagWrapper">
            <div className="HeaderHelpMenu_Tag">⇧</div>
            <div className="HeaderHelpMenu_Plus">+</div>
            <div className="HeaderHelpMenu_Tag">Click</div>
          </span>
        </div>
        <div className="HeaderHelpMenu_Row">
          <span>Skip to next track</span>

          <span className="HeaderHelpMenu_TagWrapper">
            <div className="HeaderHelpMenu_Tag">⇧</div>
            <div className="HeaderHelpMenu_Plus">+</div>
            <div className="HeaderHelpMenu_Tag">→</div>
          </span>
        </div>
        <div className="HeaderHelpMenu_Row">
          <span>Skip to previous track</span>

          <span className="HeaderHelpMenu_TagWrapper">
            <div className="HeaderHelpMenu_Tag">⇧</div>
            <div className="HeaderHelpMenu_Plus">+</div>
            <div className="HeaderHelpMenu_Tag">←</div>
          </span>
        </div>
      </ModalWindow>
    </>
  )
}

const helpMenu = enhanceWithClickOutside(HeaderHelpMenu)
export default helpMenu as any
